import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getProjectSetting, updateWbsWeekAnchor, updateWbsViewPrefs, updateWbsEvApprovalPolicy } from '../api';

export function useProjectSetting(projectId?: string, options?: { enabled?: boolean }) {
    return useQuery({
        queryKey: ['projectSetting', projectId],
        queryFn: () => getProjectSetting(projectId as string),
        enabled: !!projectId && (options?.enabled ?? true),
        staleTime: 60_000,
        refetchOnMount: 'always',
    });
}

export function useUpdateWbsWeekAnchor(projectId: string) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (params: { anchorDow: number; applyMode: 'IMMEDIATE' | 'NEXT_WEEK' }) =>
            updateWbsWeekAnchor(projectId, params),
        onSuccess: async () => {
            await Promise.all([
                qc.invalidateQueries({ queryKey: ['projectSetting', projectId] }),
                qc.invalidateQueries({ queryKey: ['wbs'] }),
                qc.invalidateQueries({ queryKey: ['dashboard-v2-snapshot', projectId] }),
                qc.invalidateQueries({ queryKey: ['project', 'dashboard', 'scurve', projectId] }),
            ]);
        },
    });
}

// ✅ 추가
export function useUpdateWbsViewPrefs(projectId: string) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (params: {
            wbsVisibilityMode?: 'SHOW_ALL_READONLY' | 'HIDE_UNASSIGNED_FOR_COMPANY';
            companyWbsDefaultView?: 'ALL' | 'ONLY_ASSIGNED';
        }) => updateWbsViewPrefs(projectId, params),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['projectSetting', projectId] }),
    });
}

export function useUpdateWbsEvApprovalPolicy(projectId: string) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (params: { wbsEvApproveBeforeClose: boolean }) => updateWbsEvApprovalPolicy(projectId, params),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['projectSetting', projectId] }),
    });
}
